import { useEffect } from "react";
import Nav from "../components/Nav";
import Hero from "../components/sections/Hero";
import PortraitReveal from "../components/sections/PortraitReveal";
import FounderStory from "../components/sections/FounderStory";
import Artists from "../components/sections/Artists";
import Studios from "../components/sections/Studios";
import Portfolio from "../components/sections/Portfolio";
import AboutUs from "../components/sections/AboutUs";
import Booking from "../components/sections/Booking";
import Location from "../components/sections/Location";
import Footer from "../components/sections/Footer";

export default function Landing() {
  useEffect(() => {
    document.title = "Fine Line & Micro Realism Tattoo Studio Sydney | JAY-INK Academy";
    const meta = document.querySelector('meta[name="description"]');
    const desc =
      "Explore Fine Line, Micro Realism, Black & Grey and custom tattoos created by the international team at JAY-INK Academy in Sydney.";
    if (meta) meta.setAttribute("content", desc);
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute("href", "https://jayink.academy/");
  }, []);

  return (
    <main data-testid="landing-page" className="bg-white text-[#0A0A0A] overflow-x-hidden">
      <Nav />
      <Hero />
      <PortraitReveal />
      <FounderStory />
      <Artists />
      <Studios />
      <Portfolio />
      <AboutUs />
      <Booking />
      <Location />
      <Footer />
    </main>
  );
}
